import { type Reducer } from "redux";
import type { ProductData } from "~/domains/product/types/ProductData";
import {
  type FCCRecommendedProductsActions,
  FINISH_FETCH_FCC_RECOMMENDED_PRODUCTS,
  START_FETCH_FCC_RECOMMENDED_PRODUCTS,
} from "~/domains/product/redux/fccRecommendationProducts/actions";

export type FccRecommendedProductsState = {
  status: string;
  productList: ProductData[];
};

const initialState: FccRecommendedProductsState = {
  status: "",
  productList: [],
};

export const fccRecommendedProductsReducer: Reducer<FccRecommendedProductsState, FCCRecommendedProductsActions> = (
  state = initialState,
  action,
): FccRecommendedProductsState => {
  switch (action.type) {
    case START_FETCH_FCC_RECOMMENDED_PRODUCTS: {
      return { ...state, status: "loading" };
    }
    case FINISH_FETCH_FCC_RECOMMENDED_PRODUCTS: {
      const { fccRecommendedProducts, error } = action.payload;
      return {
        status: error ? "error" : "loaded",
        productList: fccRecommendedProducts,
      };
    }
    default:
      return state;
  }
};
